const KITS_TABLE_READY = "kits-table-ready"
const SEARCH_TEXT_STATE = "kits-table-search-text-state"
const ROWS_PER_PAGE_STATE = "kits-table-rows-per-page-state"
const PAGINATION_STATE = "kits-table-pagination-state"

const CITY_FILTER_STATE = "kits-table-city-filter-state"
const STATE_FILTER_STATE = "kits-table-state-filter-state"
const PRODUCT_SELECT_FOR_ACTION = "kits-table-product-select-for-action"

const KITS_STORES_TABLE_READY = "kits_stores_table_ready"
const KITS_UPDATE_LOCATION_TABLE_READY = "kits_update_location_table_ready"
const KITS_PRODUCTS_TABLE_READY = "kits_products_table_ready"
const KITS_PRODUCTS_UPDATE_TABLE_READY = "kits_products_update_table_ready"








const initialState = {
    isKitsReady: true,
    isKitsUpdateLocationTableReady: true,
    isKitsStoresTableReady: true,

    isKitsProductsTableReady:true,
    isKitsProductsUpdateTableReady:true,

    productKits: {},

    previousCity: 0,
    previousState: 0,

    productSelected: null,
    
    previousSearchText: "",
    previousRowsPerPageValue: 15,
    previousPaginationValue: 1,
    
}


export default function reducer(state = initialState, action) {
    let duplicateState = null
    switch (action.type) {
        case KITS_TABLE_READY:
            return Object.assign({}, state, { isKitsReady: action.payload })
        case KITS_STORES_TABLE_READY:
            return Object.assign({}, state, { isKitsStoresTableReady: action.payload })
        case KITS_UPDATE_LOCATION_TABLE_READY:
            return Object.assign({}, state, { isKitsUpdateLocationTableReady: action.payload })
        case KITS_PRODUCTS_TABLE_READY:
            return Object.assign({}, state, { isKitsProductsTableReady: action.payload })
        case KITS_PRODUCTS_UPDATE_TABLE_READY:
            return Object.assign({}, state, { isKitsProductsUpdateTableReady: action.payload })



        
        case SEARCH_TEXT_STATE :
            duplicateState = Object.assign({}, state)
            duplicateState.previousSearchFieldText = action.payload
            return Object.assign({}, state, duplicateState)
        
        case ROWS_PER_PAGE_STATE:
            duplicateState=Object.assign({},state)
            duplicateState.previousRowsPerPageValue= action.payload
            return Object.assign({}, state, duplicateState)
        
        case PAGINATION_STATE:
            duplicateState= Object.assign({},state)
            duplicateState.previousPaginationValue = action.payload
            return Object.assign({}, state, duplicateState)

        
        case CITY_FILTER_STATE:
            return Object.assign({}, state, {previousCity:action.payload})

        case STATE_FILTER_STATE:
            return Object.assign({}, state, {previousState:action.payload})

        case PRODUCT_SELECT_FOR_ACTION:
            return Object.assign({}, state, {productSelected:action.payload})

        default:
        return state
    
    }

}

export function kitsReady(data) {
    return {
        type: KITS_TABLE_READY,
        payload: data
    }
}

export function kitsStoresTableReady(data) {
    return {
        type:KITS_STORES_TABLE_READY,
        payload: data
    }
}



export function kitsUpdateLocationTableReady(data) {
    return {
        type: KITS_UPDATE_LOCATION_TABLE_READY,
        payload: data
    }
}


export function kitsProductsTableReady(data) {
    return {
        type: KITS_PRODUCTS_TABLE_READY,
        payload: data
    }
}


export function kitsProductsUpdateTableReady(data) {
    return {
        type: KITS_PRODUCTS_UPDATE_TABLE_READY,
        payload: data
    }
}



export function searchTextState(searchText){
    return {
        type:SEARCH_TEXT_STATE,
        payload:searchText
    }
}

export function rowsPerPageState(rows){
    return {
        type:ROWS_PER_PAGE_STATE,
        payload:rows
    }
}

export function paginationState(pageNo){
    return{
        type:PAGINATION_STATE,
        payload:pageNo
    }
}

export function cityFilterState(city){
    return{
        type:CITY_FILTER_STATE,
        payload:city
    }
}

export function stateFilterState(state){
    return{
        type:STATE_FILTER_STATE,
        payload:state
    }
}

export function productSelectForAction(product){
    return{
        type:PRODUCT_SELECT_FOR_ACTION,
        payload:product
    }
}


// WEBPACK FOOTER //
// ./src/modules/Kits/redux/kits.js